"use strict";

// Logs when the client route changes
exports.onRouteUpdate = () => {
  var _window;

  if ((_window = window) !== null && _window !== void 0 && _window.OneTrust) {
    var _window$OneTrust;

    (_window$OneTrust = window.OneTrust) === null || _window$OneTrust === void 0 ? void 0 : _window$OneTrust.initializeCookiePolicyHtml();
  }
};